// HoverLink.jsx
import React from "react";

const HoverLink = ({ text, onClick, isActive }) => {
  return (
    <button
      onClick={onClick}
      className={`text-sm font-semibold underline-offset-4 transition-colors duration-200 decoration-[2px] ${
        isActive
          ? "text-[#2B8C34] underline decoration-[#2B8C34]"
          : "text-[#96A397] hover:text-[#2B8C34] hover:underline active:text-[#2B8C34] active:underline decoration-[#2B8C34]"
      }`}
    >
      {text}
    </button>
  );
};

export default HoverLink;
